import * as R from 'ramda';

export const stripTypename = <T extends object>(value: T): T =>
  R.omit(['__typename'], value as Record<string, unknown>) as T;
